type AnalyticsPayload = {
  event: string
  [key: string]: unknown
}

declare global {
  interface Window {
    dataLayer: AnalyticsPayload[]
  }
}

export enum GACategory {
  BOOK = 'book',
  USER = 'user',
  EXERCISE = 'exercise'
}

export enum GAEvent {
  BOOK_FINISHED = 'book_finished',
  BOOK_EXIT = 'book_exit',
  PROFILE_CREATE = 'create_profile',
  REGISTER = 'register',
  START_ONBOARDING = 'start_onboarding',
  FINISH_ONBOARDING = 'onboarding_finished',
  BOOK_ENTER = 'book_enter',
  PAGE_VIEW = 'page_view'
}

export const trackEvent = (payload: AnalyticsPayload) => {
  window.dataLayer = window.dataLayer || []

  window.dataLayer.push(payload)
}
